export default {
      id: "ar_commerçants-usage",
      viewBox: "0 0 80 80",
      url: "../dist/images/" + "sprite.svg#ar_commerçants-usage",
      toString: function () {
        return this.url;
      }
    }